module.exports = __webpack_public_path__ + "assets/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/favicon.ico
// module id = 1023
// module chunks = 19